<script lang="ts">
	import { t } from 'svelte-i18n';
	import PageHead from '@app/components/PageHead.svelte';
	import { ButtonBoxSecondary } from '@wiseed/wikit';
	import { capitalize } from '@wiseed/wikit';
	import { urls } from '../urls';
	import { SVG } from '@wiseed/wikit';
	import { page } from '$app/stores';
</script>

<PageHead title={$t('titles.index')} />

<section>
	<div class="container">
		<div class="flex py-4 lg:py-7 justify-center text-primary">
			<SVG name="logo_wiseed_baseline" size="giant" />
		</div>

		{#if $page.status === 404}
			<h1>{$t('404.title')}</h1>
			<p>{$t('404.message')}</p>
		{:else}
			<h1>{$t('errors.networkTitle')}</h1>
			<p>{$page.error?.body?.message ?? $page.error?.message}</p>
		{/if}
		<ButtonBoxSecondary
			props={{
				label: capitalize($t('register.confirmation.backToHome')),
				iconLeft: 'arrow_left',
				href: urls.HOME
			}}
		/>
	</div>
</section>
